import { render, staticRenderFns } from "./AddMeeting.vue?vue&type=template&id=22a6a5f4&"
import script from "./AddMeeting.vue?vue&type=script&lang=js&"
export * from "./AddMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports